var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.806,
    height: 21.009,
    viewBox: "0 0 18.806 21.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4c4e53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M116.246,0A5.455,5.455,0,1,0,121.7,5.455,5.469,5.469,0,0,0,116.246,0Z",
    transform: "translate(-110.791)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.93,251.809a5.085,5.085,0,0,0-.548-1,6.78,6.78,0,0,0-4.692-2.954,1,1,0,0,0-.691.167,5.814,5.814,0,0,1-6.86,0,.894.894,0,0,0-.691-.167,6.731,6.731,0,0,0-4.692,2.954,5.863,5.863,0,0,0-.548,1,.507.507,0,0,0,.024.453,9.5,9.5,0,0,0,.643.953,9.051,9.051,0,0,0,1.1,1.239,14.277,14.277,0,0,0,1.1.953,10.862,10.862,0,0,0,12.958,0,10.472,10.472,0,0,0,1.1-.953,11,11,0,0,0,1.1-1.239,8.351,8.351,0,0,0,.643-.953A.406.406,0,0,0,42.93,251.809Z",
    transform: "translate(-24.165 -247.841)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoUser);
export default __webpack_public_path__ + "static/media/picto_user.f0bd4b67.svg";
export { ForwardRef as ReactComponent };